import { FormControl, SelectChangeEvent } from "@mui/material";
import { useFormikContext } from "formik";
import MultiSelect from "../../../common/MultiSelect";
import { AddSolutionFormValues } from "../../add/form/types";
import { EditSolutionFormValues } from "../../edit/form/types";

const options = ["Spot", "Forward", "Other"];

function DevelopmentStageSelect() {
  const context = useFormikContext<
    AddSolutionFormValues | EditSolutionFormValues
  >();

  const handleSelectedChipRemoval = (options: string) => {
    return context.setFieldValue(
      "solution-development-stage",
      context.values["solution-development-stage"].filter(
        (selected) => selected !== options,
      ),
    );
  };

  return (
    <FormControl fullWidth variant="standard">
      <MultiSelect
        id="solution-development-stage"
        label="Development Stage"
        selectedValues={context.values["solution-development-stage"]}
        onChange={(event: SelectChangeEvent<string[]>) =>
          context.setFieldValue(
            "solution-development-stage",
            event.target.value,
          )
        }
        handleSelectedChipRemoval={handleSelectedChipRemoval}
        options={options}
      />
    </FormControl>
  );
}

export default DevelopmentStageSelect;
